<template>
  <div>
      <v-overlay :value="reload">
        <v-progress-circular
        indeterminate
        size="64"
        ></v-progress-circular>
      </v-overlay>
      <!-- dialog de exclusão -->
    <v-dialog persistent v-model="dialogExclusao" width="500">
        <v-card>
            <v-card-title class="text-h5 red darken-2 white--text">
            Tem certeza?
            </v-card-title>

            <v-card-text class="mt-4 text-center">
            Deseja realmente excluir?
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn
                    color="green darken-3"
                    class="white--text"
                    @click="excluir"
                >
                    Sim
                </v-btn>
                <v-btn
                    color="red darken-2"
                    class="white--text ms-1"
                    @click="fecharDialogExclusao"
                >
                    Não
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <div class="mt-2" v-if="msgErro.length >0 || ($v.$error && msgErro.length > 0)">
        <v-alert type="error" dense class="subtitle-2 font-weight-regular">
            <div class="p-1" v-if="msgErro.length > 0">
                <div  v-for="(erro, index) in msgErro" :key="index">
                    <span v-html="erro"></span> 
                </div>
            </div>
            <div v-else>>
                {{ msgErro }}
            </div>
        </v-alert>
    </div>
    <div>
        <v-snackbar
            v-model="snackbar"
            :app="true"
            left
            :timeout="5000"
            color="#198754"
        >
            <div class="p-1" v-if="msg.length > 0">
                <div  v-for="(msg, index) in msg" :key="index">
                    <span v-html="msg"></span> 
                </div>
            </div>
            <div v-else>>
                {{ msg }}
            </div>
        </v-snackbar>
    </div>
    <v-row>
        <v-col cols="12">
            <v-text-field 
                type="text"
                label="Cargo*" 
                filled 
                background-color="white"
                id="dscargoef" 
                v-model="dscargoef"
                disabled
            >
            </v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" lg="2" >
            <v-text-field 
                type="text"
                label="Ano do cargo*" 
                filled 
                background-color="white"
                v-mask="'####'"
                id="aatcargoef" 
                v-model="aatcargoef"
                disabled
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" lg="2"  >
            <v-text-field 
                type="text"
                label="Mês do cargo*" 
                filled 
                background-color="white"
                id="mmtcargoef" 
                v-model="mmtcargoef"
                disabled
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" lg="3" >
            <v-text-field 
                type="text"
                label="Cód Grupo do cargo*" 
                filled 
                background-color="white"
                id="cdgcargoef" 
                v-model="cdgcargoef"
                disabled
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" lg="3" >
            <v-text-field 
                type="text"
                label="Grupo do cargo*" 
                filled 
                background-color="white"
                id="dsgcargoef" 
                v-model="dsgcargoef"
                disabled
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" lg="2" >
            <v-text-field 
                type="text"
                label="Cód do cargo*" 
                filled 
                background-color="white"
                id="cdcargoef" 
                v-model="cdcargoef"
                disabled
            >
            </v-text-field>
        </v-col>
    </v-row>
    <v-row >
        <v-col cols="12" lg="2" >
            <v-text-field 
                type="text"
                label="Cód da especialidade*" 
                filled 
                background-color="white"
                id="cdespecia" 
                v-model="cdespecia"
                disabled
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" lg="10">
            <v-text-field 
                type="text"
                label="Especialidade*" 
                filled 
                background-color="white"
                id="dsespecia" 
                hide-details="auto"
                v-model="dsespecia"
                v-debounce:1s="listarEspecialidades"
                autocomplete="off"
            >
            </v-text-field>
            <v-sheet class="lista-select">
                <v-list class="" dense v-if="listaDeEspecialidades.length > 0 && !reload">
                    <v-list-item class="lista-select-item lista-select-group"  v-for="(registro, index) in listaDeEspecialidades" :key="index" >
                        <v-list-item-content class="lista-item-content" @click="selecionaEspecialidade(registro)">
                            {{ `${registro.cdespecia} - ${registro.dsespecia}`}}
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-sheet>
        </v-col>
    </v-row>
    <!-- <v-row> -->
        <v-card>
            <v-toolbar flat color="primary">
                <v-toolbar-title class="white--text">Atuações</v-toolbar-title>

            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" lg="12">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label=""
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" lg="1">
                        <v-btn color="primary" @click="novo">Novo</v-btn>
                    </v-col> -->
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                                :headers="headers"
                                :items="especialidadesAtuacaoDoCargo"
                                :items-per-page="10"
                                :header-props="headerProps"
                                class="elevation-1"
                                :loading="carregandoDadosTabela"
                                :search="search"
                                loading-text="Carregando dados. Por favor espere."
                                :footer-props="{
                                    'items-per-page-text':'Itens por página',
                                    'items-per-page-all-text':  'Todos',
                                    'pageText': '{0}-{1} de {2}'
                                }"
                        >
                            <template slot="no-data">
                                <span style="text-align:center">Nenhum dado para mostrar.</span>
                            </template>
                            
                            <template v-slot:item.iduso="{ item }">
                                <v-icon
                                    small
                                    color="teal"
                                    class="mr-2"
                                    v-if="item.iduso === 'S'"
                                >
                                    mdi-check-bold
                                </v-icon>
                                <v-icon
                                    small
                                    color="#E53935"
                                    class="mr-2"
                                    v-else
                                >
                                    mdi-close-thick
                                </v-icon>
                            </template>
                            <template v-slot:item.idacao="{ item }">
                                <v-icon
                                    small
                                    color="primary"
                                    class="mr-2"
                                    @click="editarConfiguracao(item)"
                                >
                                    mdi-pencil
                                </v-icon>
                                <v-icon
                                    small
                                    color="error"
                                    class="mr-2"
                                    @click="exibirDialogExclusao(item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            
                            <template v-slot:top>
                                
                                <v-dialog v-model="dialogEdit"  persistent fullscreen>
                                    <v-overlay :value="reload">
                                        <v-progress-circular
                                        indeterminate
                                        size="64"
                                        ></v-progress-circular>
                                    </v-overlay>
                                    <v-card>
                                        <v-card-title class="p-4" >
                                        {{ (acao === 'insercao') ? 'Novo' : 'Editar' }}
                                        </v-card-title>
                                        <v-card-text class="p-4">
                                            <div class="mt-2" v-if="msgErro.length >0 || ($v.$error && msgErro.length > 0)">
                                                <v-alert type="error" dense class="subtitle-2 font-weight-regular">
                                                    <div class="p-1" v-if="msgErro.length > 0">
                                                        <div  v-for="(erro, index) in msgErro" :key="index">
                                                            <span v-html="erro"></span> 
                                                        </div>
                                                    </div>
                                                    <div v-else>>
                                                        {{ msgErro }}
                                                    </div>
                                                </v-alert>
                                            </div>
                                            <div>
                                                <v-text-field 
                                                    type="text"
                                                    label="Cód Atuação*" 
                                                    filled 
                                                    background-color="white"
                                                    id="cddiscipl" 
                                                    v-model="cddiscipl"
                                                    disabled                                        
                                                >
                                                </v-text-field>
                                            </div>
                                            <div>
                                                <v-text-field 
                                                    type="text"
                                                    label="Atuação*" 
                                                    filled 
                                                    :error=" ($v.dsdiscipl.required === false ) && $v.$dirty === true ? true : false"
                                                    :error-messages=" ($v.dsdiscipl.required === false ) && $v.$dirty === true ? messages.required : '' "
                                                    background-color="white"
                                                    id="dsdiscipl" 
                                                    hide-details="auto"
                                                    v-model="dsdiscipl"
                                                    v-debounce="listarDisciplinas"
                                                    :disabled="acao === 'edicao'"
                                                    autocomplete="off"
                                                >
                                                </v-text-field>
                                                <v-sheet class="lista-select">
                                                    <v-list class="" dense v-if="listaDeDisciplinas.length > 0 && !reload">
                                                        <v-list-item class="lista-select-item lista-select-group"  v-for="(registro, index) in listaDeDisciplinas" :key="index" >
                                                            <v-list-item-content class="lista-item-content" @click="selecionaDisciplina(registro)">
                                                                {{ `${registro.cddiscipl} - ${registro.dsdiscipl}`}}
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-sheet>
                                            </div>
                                            <div class="d-flex align-center">
                                                <span class="pe-4">Em uso?*</span>
                                                <v-switch
                                                    inset
                                                    true-value="S"
                                                    false-value="N"
                                                    v-model="iduso"
                                                    color="primary"
                                                    :error=" ($v.iduso.required === false ) && $v.$dirty === true ? true : false"
                                                    :error-messages=" ($v.iduso.required === false ) && $v.$dirty === true ? messages.required : '' "
                                                >
                                                </v-switch>
                                            </div>
                                            
                                            <div class="d-flex justify-center">
                                                <v-btn depressed color="success" @click="salvar" :loading="loading" :disabled="loading"> OK</v-btn>
                                                <v-btn class="ml-4" v-if="acao === 'edicao'" depressed color="error" @click="exibirDialogExclusao(configuracaoEmEdicao)" :loading="loading" :disabled="loading"> Excluir</v-btn>
                                                <span class="ml-4">
                                                    <v-btn depressed color="normal" @click="fecharDialogEdit"> Cancelar </v-btn>
                                                </span>
                                            </div>
                                        </v-card-text>
                                    </v-card>

                                </v-dialog>
                            </template>

                        </v-data-table>

                    </v-col>

                </v-row>

            </v-card-text>
        </v-card>
    <!-- </v-row> -->
    <v-row class="mt-4">
        <div class="d-flex justify-end">
            <router-link :to="{ name: 'pesquisa-configuracao-distribuicao'}" style="text-decoration: none;">
                <v-btn depressed color="blue-grey white--text">Voltar</v-btn>
            </router-link>
            <div class="ms-1">
                <v-btn color="primary" @click="novo">Novo</v-btn>
            </div>
        </div>
    </v-row>


  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Buscar from '../../components/Buscar.vue'
import especialidades from '../../api/especialidades'
import cargoEspecialidades from '../../api/cargo-especialidades'
import disciplinas from '../../api/disciplinas'
import  messages  from '../../utils/messages'
import {retiraAcentos} from '@/utils/retiraAcentos'


export default {
    name: 'EspecialidadesEAtuacao',
    components: {
        Buscar,
    },

    data() {
        return {
            aatcargoef: this.$route.params.aatcargoef,
            mmtcargoef: this.$route.params.mmtcargoef,
            cdgcargoef: this.$route.params.cdgcargoef,
            cdcargoef: this.$route.params.cdcargoef,
            dsgcargoef: this.$route.query.dsgcargoef,
            dscargoef: this.$route.query.dscargoef,
            reload: false,
            dialogExclusao: false,
            dialogEdit: false,
            msgErro: [],
            msg: [],
            search: '',
            acao: '',
            listaDeEspecialidades: [],
            listaDeDisciplinas: [],
            carregandoDadosTabela: false,
            cdespecia: 0,
            dsespecia: '',
            cddiscipl: '',
            dsdiscipl: '',
            loading: false,
            especialidadeSelecionada: {},
            configuracaoEmEdicao: {},
            configuracaoSelecionadoExclusao: {},
            iduso: 'S',
            especialidadesAtuacaoDoCargo: [],
             messages: messages,
            headerProps: {
                sortByText: "Ordernar por"
            },
            headers: [
                        { text: "Cód. Atuação", value: "cddiscipl" },
                        {
                            text: "Atuação",
                            align: "start",
                            sortable: true,
                            value: "dsdiscipl",
                        },
                        { text: "Em uso?", value: "iduso", align: "center" },
                        { text: "", value: "idacao", align: "center" },
                        
                    ],

        }
    },
    watch: {
        
        especialidadeSelecionada: async function(newValue, oldValue) {
           try {
               if(Object.keys(newValue).length > 0){
                   this.atualizarTabelaAtuacoes()
               }
           }
           catch(erro) {
                this.carregandoDadosTabela = false
                this.msgErro = erro.response.data.mensagem
           }
        },
        dsespecia: function (newValue, oldValue) {
            try {
               if(newValue === ''){
                   this.especialidadeSelecionada = {}
                   this.cdespecia = 0
                   this.atualizarTabelaAtuacoes()
               } 
           }
           catch(erro) {
                this.carregandoDadosTabela = false
                this.msgErro = erro.response.data.mensagem
           }
        },
        dsdiscipl: function (newValue, oldValue) {
            if(newValue === '') {
                this.disciplinaSelecionada = {}
            }
        }

    },
    computed: {
        snackbar: {
            get() {
                return this.msg.length > 0
            },
            set() {
                return this.msg.length > 0
            }
        },
    },
     validations: () =>({
        aatcargoef: {required},
        mmtcargoef: {required},
        cdgcargoef: {required},
        cdcargoef: {required},
        dsdiscipl: {required},
        cddiscipl: {required},
        iduso: {required},
       // especialidadeSelecionada: {required}
     }),

     async created() {
         this.atualizarTabelaAtuacoes()
     },
     
     methods: {
         selecionaEspecialidade(especialidade) {
             this.cdespecia = especialidade.cdespecia 
             this.dsespecia = especialidade.dsespecia
             this.especialidadeSelecionada = especialidade
             this.listaDeEspecialidades = []
         },
         selecionaDisciplina(disciplina) {
             this.cddiscipl = disciplina.cddiscipl
             this.dsdiscipl = disciplina.dsdiscipl
             this.disciplinaSelecionada = disciplina
             this.listaDeDisciplinas = []
         },
         async listarEspecialidades() {
             
             this.msgErro = []
             this.msg = []
             
             try {
                 if(this.dsespecia === '') {
                     this.listaDeEspecialidades = []
                     this.cdespecia = 0
                     this.especialidadesAtuacaoDoCargo = []
                     return
                 }
                 this.reload = true
                 const {data} = await especialidades.buscarEspecialidade(retiraAcentos(this.dsespecia.toUpperCase()))
                 this.listaDeEspecialidades = data.especialidades
                 this.reload = false
                 

             }
             catch(erro) {
                 this.reload = false
                 this.msgErro = erro.response.data.mensagem
             }

         },
         async listarDisciplinas() {
             this.msgErro = []
             this.msg = []
             this.reload = false
             this.listaDeDisciplinas = []
             try {
                 if(this.dsdiscipl === '') return
                 this.reload = true
                 const {data} = await disciplinas.buscarDisciplina(retiraAcentos(this.dsdiscipl.toUpperCase()))
                 this.listaDeDisciplinas = data.disciplinas
                 this.reload = false

             }
             catch(erro) {
                 this.reload = false
                 this.msgErro = erro.response.data.mensagem
             }

         },
         async atualizarTabelaAtuacoes() {
             try {
                 this.carregandoDadosTabela = true
                 const {data} = await cargoEspecialidades.obterConfiguracaoEspecialidadeAtuacao(this.aatcargoef, this.mmtcargoef, this.cdgcargoef, this.cdcargoef, this.cdespecia)
                 this.especialidadesAtuacaoDoCargo = data.configuracoes
                 this.carregandoDadosTabela = false

             }
             catch(erro) {
                 this.reload = false
                 this.msgErro = erro.response.data.mensagem
             }

         },
         novo() {

             this.msgErro = []
             this.acao = 'insercao'
             this.iduso = 'S'
             this.cddiscipl = ''
             this.dsdiscipl = ''
             this.dialogEdit = true
             this.$v.$reset()
         },
         fecharDialogEdit() {
             this.dialogEdit = false
             this.cddiscipl = ''
             this.dsdiscipl = ''
             this.iduso = ''
             this.acao = ''
             this.msgErro = []
         },
         exibirDialogExclusao(cargo) {
            this.configuracaoSelecionadoExclusao = cargo 
            this.dialogExclusao = true
        },
        fecharDialogExclusao() {
             this.dialogExclusao = false
             this.cddiscipl = ''
             this.dsdiscipl = ''
             this.iduso = ''
             this.acao = ''
         },
         editarConfiguracao(item) {
             this.cddiscipl = item.cddiscipl
             this.dsdiscipl = item.dsdiscipl
             this.iduso = item.iduso
             this.configuracaoEmEdicao = item
             this.acao = 'edicao'
             this.dialogEdit = true
         },
         async salvar(){
             
             this.msgErro = []
             this.msg = []
            if(this.validarDialog()) return

             try {
                 this.reload = true
                 const {data} = await cargoEspecialidades.salvar({
                                                                    aatcargoef: this.aatcargoef,
                                                                    mmtcargoef: this.mmtcargoef,
                                                                    cdgcargoef: this.cdgcargoef,
                                                                    cdcargoef: this.cdcargoef,
                                                                    cdespecia: this.cdespecia,
                                                                    cddiscipl: this.cddiscipl,
                                                                    iduso: this.iduso,
                                                                })
                this.atualizarTabelaAtuacoes()
                this.reload = false
                this.dialogEdit = false
                this.msg = [data.mensagem[0]]
                this.$v.$reset()

             }
             catch(erro) {
                 this.reload = false
                 this.msgErro = erro.response.data.mensagem

             }

         },
         async excluir() {
             try {
                this.msgErro = []
                this.msg = []
                this.dialogExclusao = false
                this.dialogEdit = false
                this.reload = true
                const {data} = await cargoEspecialidades.excluir(this.aatcargoef, this.mmtcargoef,this.cdgcargoef, this.cdcargoef, this.cdespecia, this.configuracaoSelecionadoExclusao.cddiscipl)
                this.atualizarTabelaAtuacoes()
                this.reload = false
                this.msg = [data.mensagem[0]]
                this.configuracaoSelecionadoExclusao = {}

             }
             catch(erro) {
                 this.reload = false
                 this.msgErro = erro.response.data.mensagem

             }

         },
         validarDialog() {
            
            let erro = false
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.msgErro = ['Preencha os campos corretamente']
                this.reload = false;
                erro = true
            }
            return erro

         }
     },
}
</script>

<style>
.lista-select {
    z-index: 8;
    position: absolute;
    width: 500px;
    border-radius: 5;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 
                0px 1px 3px 0px rgb(0 0 0 / 12%) !important;
    
}


.lista-select-group:hover {
     background-color: #315E7E;
    color: white;
    cursor: pointer;

}

.lista-select-item:hover {
    background-color: #315E7E;
    cursor: pointer;

}

.lista-item-content:hover{
    color: white;
}

</style>